import Dialog from '../mixins/dialog';
import ListPage from '../mixins/listPage';
import CampusListPage from '../mixins/campusListPage';
import Operator from '../mixins/operator';
import Admin from '../mixins/admins/admins';
import Menu from '../mixins/menu/menus';
import UserInfoLabel from '../mixins/user/getUserInfoLabel';
import BaseInfo from '../mixins/user/userBaseInfo';
import Validate from '../mixins/user/validate';
import Area from '../components/input/AreaSelect/mixin';
import BaseData from '../components/input/BaseDataSelect/mixin';
import BeanType from '../components/input/BeanTypeSelect/mixin';
import OperatorOptions from '../components/input/OperatorSelect/mixin';
import ServiceType from '../components/input/ServiceTypeSelect/mixin';
import AreaService from '../components/input/AreaServiceSelect/mixin';
import OperatorArea from '../components/input/AreaDashboard/mixin';
import SearchBar from '../mixins/searchBar';

export default {
  Dialog,
  ListPage,
  SearchBar,
  CampusListPage,
  Operator,
  Admin,
  Menu,
  User: {
    BaseInfo,
    UserInfoLabel,
    Validate,
  },
  Input: {
    Area,
    OperatorArea,
    BaseData,
    BeanType,
    OperatorOptions,
    ServiceType,
    AreaService,
  },
};
